import { useQuery } from '@apollo/client/react';
import { Alert, Box, CircularProgress, Paper, Typography } from '@mui/material';
import { GET_MY_REWARD_PROGRAMS } from '../queries/profile';

interface RewardProgramsData {
  programs: {
    progress_url: string;
  };
}

const RewardsPage = () => {
  const { loading, error, data } = useQuery<RewardProgramsData>(GET_MY_REWARD_PROGRAMS);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">Error loading rewards program: {error.message}</Alert>
      </Box>
    );
  }

  const progressUrl = data?.programs?.progress_url;

  if (!progressUrl) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="info">No rewards program available</Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ height: 'calc(100vh - 64px)', display: 'flex', flexDirection: 'column', p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Rewards Program
      </Typography>
      
      <Paper sx={{ flex: 1, overflow: 'hidden' }}>
        <iframe
          src={progressUrl}
          title="Rewards Progress"
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
          }}
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
        />
      </Paper>
    </Box>
  );
};

export default RewardsPage;
